import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import InputComponent from "./commonComponents/InputComponent";
import styled from 'styled-components'
import { performLogin } from "../slices/authSlice";


const LoginForm = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userData = useSelector((state) => state.auth.userData);
    const accessToken = useSelector((state) => state.auth.userData?.accessToken);

    useEffect(() => {
        if (accessToken) {
            navigate('/dashboard');
        }
    }, [accessToken])


    const handleLogin = async () => {
        setLoading(true);

        if (!email || !password) {
            toast.warning("Please fill all details", {
                position: "top-right",
                autoClose: 5000,
                pauseOnHover: true,
                theme: "dark",
                className: "toastify",
            })
            setLoading(false);
            return;
        }

        if (email && password) {
            try {
                dispatch(performLogin({ password, email }))
            } catch (error) {
                const errMsg = error.response.data.message || "Some error occured"
                toast.error(errMsg, {
                    position: "top-right",
                    autoClose: 5000,
                    pauseOnHover: true,
                    theme: "dark",
                    className: "toastify",
                })
                setLoading(false);
                return;
            }
        }
    }


    return (
        <Box>
            <InputComponent
                state={email}
                setState={setEmail}
                type="email"
                placeholder="Email"
                required={true}
            />
            <InputComponent
                state={password}
                setState={setPassword}
                type="password"
                placeholder="Password"
                required={true}
            />
            <button disabled={loading} onClick={handleLogin} className="customBtn">
                {loading ? "Loading" : "Login"}
            </button>
        </Box>
    );
};

export default LoginForm;


const Box = styled.div`
display: flex;
flex-direction: column;
width: 100%;
align-items: center;


.customBtn {
  text-align: center;
  padding: 1.2rem 2.5rem;
  border-radius: 0.40rem;
  cursor: pointer;
  margin: 1rem;
  font-size: 2.3rem;
  font-weight: 600;
  background-color: var(--orange);
  color: var(--white);
  border-style: none;
}

  

`
